import { render } from "./FeeTemplateManageView.vue?vue&type=template&id=6779cc7b&scoped=true"
import script from "./FeeTemplateManageView.vue?vue&type=script&lang=js"
export * from "./FeeTemplateManageView.vue?vue&type=script&lang=js"

import "./FeeTemplateManageView.vue?vue&type=style&index=0&id=6779cc7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6779cc7b"]])

export default __exports__